import { SvgIcons } from "Icon/SvgIcons";
import React from "react";

export const JobTitles = [
  "UI Designer",
  "UX/UI Designer",
  "Graphic Designer",
  "Design Intern",
  "+6",
];

export const Skills = ["UX Design", "Prototyping", "Wireframing", "Design Systems", "+6"];
export const Certificates = [
  "UX Design Norman Nelson Certificate ",
  "UX Design Norman Nelson Certificate ",
  "+14",
];

export interface IExperienceWithType {
  type: string;
  year: number;
}
export const ExperienceWithType = [
  {
    type: "General",
    year: 12,
  },
  {
    type: "Current",
    year: 3,
  },
];

export const experienceData = [
  {
    role: "Sr. UX Designer",
    company: "Boltshift",
    duration: "Jun 2020 - Sep 2023 (3y, 2m)",
  },
  {
    role: "UI/UX Designer ",
    company: "Cirrus Inc. ",
    duration: "Jun 2020 - Sep 2023 (3 y, 2 m)",
  },
];

export const EducationDetails = [
  {
    stream: "Master of Sience",
    branch: "Design",
    university: "New York University",
    year: "2006",
  },
  {
    stream: "Bachelor of Sience",
    branch: "Design",
    university: "New York University",
    year: "2001",
  },
];

export interface ISocialMedia {
  icon: React.ReactNode; // Since these are SVG icons, using React.ReactNode for flexibility
}
export const SocialMedia = [
  { icon: SvgIcons.whatsappSvg },
  { icon: SvgIcons.slackSvg },
  { icon: SvgIcons.linkedinSvg },
  { icon: SvgIcons.mailBigSvg }
];
export const LikeShareIcon = [
  { icon: SvgIcons.heartSvg },
  { icon: SvgIcons.downthumbSvg },
  { icon: SvgIcons.shareSvg },
  { icon: SvgIcons.dottedmenuSvg },
];

export const filtersSidebarData = [
  // { label: "Create or select project", example: "UX designer for IBM", nav:"project" },
  { label: "Add Search Title", example: "UX designer, 1 iteration", nav:"title" },
  { label: "Add Job Title", example: "UX designer", nav:"job_titles" },
  { label: "Add any keywords", example: "expert, pro", nav:"keywords" },
  // { label: "Add skills", example: "Wireframing", nav:"skills" },
  { label: "Add Experience", example: "3-5 years", nav:"work_experiences" },
  { label: "Add location", example: "New York", nav:"locations" },
  { label: "Add Education", example: "NY School", nav:"education" },
];
